export default [{
    path: '/spot/trade-spot/:pairs?',
    name: 'trade-spot',
    component: () => import('@/pages/proTrading'),
},{
    path: '/spot/trade-hybrid/:pairs?',
    name: 'trade-hybrid',
    component: () => import('@/pages/proTrading/hybrid'),
}]



// WEBPACK FOOTER //
// ./src/router/proTrading.js